export const paymentStatus = {
  open: 'Aberto',
  canceled: 'Cancelado',
  paid: 'Pago',
  closed: 'Fechado'
}
